export default "__VITE_ASSET__D25DMoy3__"